/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ff: NonNullable<unknown> }} Building_Holidays_Settings_Text_1Inputs */

const fr_building_holidays_settings_text_1 = /** @type {((inputs: Building_Holidays_Settings_Text_1Inputs) => LocalizedString) & { parts: (inputs: Building_Holidays_Settings_Text_1Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Holidays_Settings_Text_1Inputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`En période Hors Gel, les têtes thermostatiques régulent à ${i?.ff}°C (Température Hors Gel)`)
		}),
		{
			parts: /** @type {(inputs: Building_Holidays_Settings_Text_1Inputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "En période Hors Gel, les têtes thermostatiques régulent à " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.ff) }, { type: "text", value: "°C (Température Hors Gel)" }, { type: "markup-end", name: "span", options: {}, attributes: {} }])
			})
		}
	)
);

const en_building_holidays_settings_text_1 = /** @type {((inputs: Building_Holidays_Settings_Text_1Inputs) => LocalizedString) & { parts: (inputs: Building_Holidays_Settings_Text_1Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Holidays_Settings_Text_1Inputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`During frost-free period, thermostatic heads regulate at ${i?.ff}°C (Frost-free temperature)`)
		}),
		{
			parts: /** @type {(inputs: Building_Holidays_Settings_Text_1Inputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "During frost-free period, thermostatic heads regulate at " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.ff) }, { type: "text", value: "°C (Frost-free temperature)" }, { type: "markup-end", name: "span", options: {}, attributes: {} }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "During frost-free period, thermostatic heads regulate at {ff}°C (Frost-free temperature)" |
*
* @param {Building_Holidays_Settings_Text_1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_holidays_settings_text_1 = /** @type {((inputs: Building_Holidays_Settings_Text_1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs: Building_Holidays_Settings_Text_1Inputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Building_Holidays_Settings_Text_1Inputs, { locale?: "fr" | "en" }, { span: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Holidays_Settings_Text_1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_building_holidays_settings_text_1(inputs)
			return fr_building_holidays_settings_text_1(inputs)
		}),
		{
			parts: /** @type {(inputs: Building_Holidays_Settings_Text_1Inputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Building_Holidays_Settings_Text_1Inputs) => import('../runtime.js').MessagePart[] }} */ (en_building_holidays_settings_text_1).parts?.(inputs) ?? [{ type: "text", value: en_building_holidays_settings_text_1(inputs) }]
				return /** @type {{ parts?: (inputs: Building_Holidays_Settings_Text_1Inputs) => import('../runtime.js').MessagePart[] }} */ (fr_building_holidays_settings_text_1).parts?.(inputs) ?? [{ type: "text", value: fr_building_holidays_settings_text_1(inputs) }]
			})
		}
	)
);